import PropTypes from 'prop-types'

export const AccountStatusPropTypes = PropTypes.shape({
    hasError: PropTypes.bool.isRequired,
    isAccountInClan: PropTypes.bool.isRequired,
    isFetchingCompleted: PropTypes.bool.isRequired,
})

export const JoinResultPropTypes = PropTypes.shape({
    cooldownTill: PropTypes.string,
    currentClan: PropTypes.shape({
        color: PropTypes.string.isRequired,
        emblem: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        tag: PropTypes.string.isRequired,
    }),
    hasNoErrors: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    applied: PropTypes.array.isRequired,
    joinedClan: PropTypes.shape({
        color: PropTypes.string.isRequired,
        emblem: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        tag: PropTypes.string.isRequired,
    }),
    loading: PropTypes.bool.isRequired,
})

export const RecommendedClanPropTypes = PropTypes.shape({
    color: PropTypes.string,
    emblems: PropTypes.object.isRequired,
    id: PropTypes.number.isRequired,
    isClanAcceptableForAutoJoining: PropTypes.bool.isRequired,
    isRecruitingOpened: PropTypes.bool.isRequired,
    languages: PropTypes.arrayOf(PropTypes.string).isRequired,
    membersCount: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    tag: PropTypes.string.isRequired,
    dwhSquadScore: PropTypes.number,
    dwhStrongholdScore: PropTypes.number,
    dwhGlobalMapScore: PropTypes.number,
    dwhClanReservesScore: PropTypes.number,
    strongholdLevel: PropTypes.number,
    status: PropTypes.string,
})

export const RecommendedClansPropTypes = PropTypes.arrayOf(RecommendedClanPropTypes)



// WEBPACK FOOTER //
// ./containers/Landing/propTypes.js